module.exports = __webpack_public_path__ + "img/acme-corp.82be7c71.png";